/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EPlotType {
  hotspot = 0,
  geofence = 1,
  workOrder = 2,
  garmin = 3,
  vehicle = 4,
  harshDrivingEvent = 5,
  balloon = 6,
  asset = 7,
  replay = 8,
  polyline = 9,
  poweredAsset = 10,
  cluster = 11,
  // Polyline dot is the small circle marker that appears at the start and end of an NPA polyline
  polylineDayDot = 12
}

export enum ECombinedPlotType {
  vehicleWithIssue = 100,
  chargingDeviceWithIssue = 101,
  assetWithIssue = 102,
  poweredAssetWithIssue = 103
}

export type EAllPlotTypes = EPlotType | ECombinedPlotType;

/**
 * Classifies a {@link EPlotType} into vehicle categories, so callers don't compare against
 * {@link EPlotType} members inline (e.g. `plotType === EPlotType.poweredAsset`).
 */
export class PlotTypeClassifier {
  /** Returns true when the given plot type represents a powered asset. */
  public static isPoweredAsset(plotType: EPlotType | null | undefined): boolean {
    return plotType === EPlotType.poweredAsset;
  }
}
